module.exports = __webpack_public_path__ + "img/16-s.0cf9cad1.png";